module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_09.60003e11.jpg";